/**
 * Types of export status
 * @enum {number}
 * @readonly
 */
const TExportStatus = {
    /**
     * Type undefined
     * @type {number}
     * @constant
     */
    UNDEFINED: 0,
    /**
     * Type in progress
     * @type {number}
     * @constant
     */
    IN_PROGRESS: 1,
    /**
     * Type resolved
     * @type {number}
     * @constant
     */
    RESOLVED: 2,
    /**
     * Type rejected
     * @type {number}
     * @constant
     */
    REJECTED: 3,
    /**
     * Type waiting
     * @type {number}
     * @constant
     */
    WAITING: 4,
    /**
     *
     * Type canceled
     * @type {number}
     * @constant
     */
    CANCELED: 5,
}

export default TExportStatus
